
<div class="card avatar-creation-container font-title">
  <div class="card-body">
    <div class="d-flex flex-column align-items-center text-center">
      <h1>{{ 'avatarCreation.heading' | translate }}</h1>
      <p *ngIf="userAvatarStatus == 'USE_EXISTING'">{{ 'avatarCreation.text1' | translate }} </p>
      <p *ngIf="userAvatarStatus == 'CREATE_NEW'">{{ 'avatarCreation.text2' | translate }}</p>
      <mat-spinner *ngIf="loading"></mat-spinner>
      <div *ngIf="!loading" id="svg-container" [innerHTML]="safeAvatarSVG"></div>
      <!--    -->
      <div class="mt-3">
        <div class="secondary-selection-container" id="secondary-selection-container">
        </div>
        <div *ngIf="avatarType == 'HUMAN'" class="primary-selection-container">
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="avatarType">
            <mat-icon class="vertical-align-middle">account_circle</mat-icon> {{ 'avatarCreation.text3' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="top">
            <mat-icon class="vertical-align-middle">face</mat-icon> {{ 'avatarCreation.text4' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="hairColor">
            <mat-icon class="vertical-align-middle">palette</mat-icon> {{ 'avatarCreation.text5' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="facialHair">
            <mat-icon svgIcon="facial-hair" class="vertical-align-middle"></mat-icon> {{ 'avatarCreation.text6' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="facialHairColor">
            <mat-icon class="vertical-align-middle">palette</mat-icon> {{ 'avatarCreation.text7' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="accessories">
            <mat-icon svgIcon="accessories-icon" class="vertical-align-middle"></mat-icon> {{ 'avatarCreation.text8' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="accessoriesColor">
            <mat-icon class="vertical-align-middle">palette</mat-icon> {{ 'avatarCreation.text9' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="clothes">
            <mat-icon class="vertical-align-middle">checkroom</mat-icon> {{ 'avatarCreation.text10' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="clothesColor">
            <mat-icon class="vertical-align-middle">palette</mat-icon> {{ 'avatarCreation.text11' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="clotheGraphics">
            <mat-icon class="vertical-align-middle">checkroom</mat-icon> {{ 'avatarCreation.text12' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="eyes">
            <mat-icon svgIcon="eye-icon" class="vertical-align-middle"></mat-icon> {{ 'avatarCreation.text13' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="eyebrow">
            <mat-icon svgIcon="eyebrows-icon" class="vertical-align-middle"></mat-icon> {{ 'avatarCreation.text14' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="mouth">
            <mat-icon svgIcon="mouth-icon" class="vertical-align-middle"></mat-icon> {{ 'avatarCreation.text15' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="skin">
            <mat-icon class="vertical-align-middle">perm_identity</mat-icon> {{ 'avatarCreation.text16' | translate }}
          </button>

        </div>
        <div *ngIf="avatarType == 'ROBOT'" class="primary-selection-container">
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="avatarType">
            <mat-icon class="vertical-align-middle">account_circle</mat-icon> {{ 'avatarCreation.text17' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="colors">
            <mat-icon class="vertical-align-middle">palette</mat-icon>  {{ 'avatarCreation.text18' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="colorful">
            <mat-icon class="vertical-align-middle">palette</mat-icon>  {{ 'avatarCreation.text19' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="primaryColorLevel">
            <mat-icon class="vertical-align-middle">opacity</mat-icon> {{ 'avatarCreation.text20' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="secondaryColorLevel">
            <mat-icon class="vertical-align-middle">opacity</mat-icon> {{ 'avatarCreation.text21' | translate }}
          </button>
          <button class="btn btn-primary" (click)="addStyleButtonsToSecondarySelectionMenu($event)" attr-name="textureChance">
            <mat-icon class="vertical-align-middle">texture</mat-icon> {{ 'avatarCreation.text22' | translate }}
          </button>
        </div>
        <button class="btn btn-primary"(click)="regenerateAvatarButtonClick()">
          <mat-icon class="vertical-align-middle">casino</mat-icon> {{ 'avatarCreation.text23' | translate }}
        </button>
        <button class="btn btn-primary" (click)="saveAvatar()">
          <mat-icon class="vertical-align-middle">save</mat-icon> {{ 'avatarCreation.text24' | translate }}
        </button>
        <button class="btn btn-primary" (click)="backToHome()">
          <mat-icon class="vertical-align-middle">home</mat-icon> {{ 'avatarCreation.text25' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
